$(-> 
  ## TODO: brittany 10/5 - Possibly stale? #question_library is used in three instances of content_for :sidebar on the admin side - job builder questionnaires, regular questionnaires, and extra field sets - and has remained virtually untouched for 6 years.  Not seeing a sidebar anywhere.
  $(document).on 'ajax:success', '#question_library a', (event,data,status,xhr)->
    $('#add_question_link').click()
    new_question = $('#questions > .nested-fields:last')
    $.each(['name','question_type','answer_id','weight'], (i,e)->
      new_question.find('[data-field="' + e + '"]').val(data[e])
    )
    $.each(data.answers, (i,a)->
      new_question.find('a.add_fields').click()
      new_answer = new_question.find('.answers > .nested-fields:last')
      $.each(['name','score'], (i,e)->
        new_answer.find('[data-field="' + e + '"]').val(a[e])
      )
    )

)